import Modal from './Modal';

class SimpleModal extends Modal {
  cbOnModalClose(): void {}

  cbOnModalOpen(): void {
    // Handle image scrolling for mobile view
    if (window.innerWidth <= 768) {
      this.scrollImageIntoView();
    }
  }

  private scrollImageIntoView(): void {
    const modalImages = this.modal.querySelectorAll('.modal__image');

    modalImages.forEach(imageEl => {
      if (imageEl && imageEl.hasAttribute('data-x')) {
        const scrollPercentage = imageEl.getAttribute('data-x');
        if (scrollPercentage) {
          // Convert percentage string to number (remove % if present)
          const percentage =
            parseFloat(scrollPercentage.replace('%', '')) / 100;

          // Calculate scroll position
          const totalScrollWidth = imageEl.scrollWidth - imageEl.clientWidth;
          const scrollPosition = totalScrollWidth * percentage;

          // Scroll the element
          setTimeout(() => {
            imageEl.scrollLeft = scrollPosition;
          }, 300); // Small delay to ensure modal is fully visible
        }
      }
    });
  }
}

export default SimpleModal;
